import { CornerInfo, DrawingEdge } from '~/core/models';

export const updateCornerReplacementCoords = (
  startPt: CornerInfo,
  endPt: CornerInfo,
  currentEdge: DrawingEdge
): void => {
  startPt.replacementEndCoords = currentEdge.startDisplayVec;
  endPt.replacementStartCoords = currentEdge.endDisplayVec;
};
